export interface DropdownFilter {
  label?: string;
  value?: any;
  items?: Array<{ label: string; value: any }>;
  parent?: any;
}
